import comp from "./Settings";
export default comp;
